import { render, staticRenderFns } from "./InspiniaIbox.vue?vue&type=template&id=1612511d&"
import script from "./InspiniaIbox.vue?vue&type=script&lang=ts&"
export * from "./InspiniaIbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports